import type { User } from "@lumen/shared";
import { SiteOrganizationsWorkspace } from "./SiteOrganizationsWorkspace";

export function SiteOrganizationsPage({
  permissions,
  user,
}: {
  permissions: string[];
  user: User;
}) {
  return (
    <SiteOrganizationsWorkspace
      permissions={permissions}
      user={user}
      mode="list"
    />
  );
}
